import { assertUniqueName, clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getRegion } from './get-region';

/** `POST /client/:cid/regions {name, hub_ids: []}`; the route also gives the creator access to the region. */
export const createRegion = async (name: string): Promise<any> => {
  assertUniqueName((await lpRequest('GET', clientPath('/regions'))) || [], name, 'region');
  const { id } = await lpRequest('POST', clientPath('/regions'), {
    body: { name: name.trim(), hub_ids: [] }
  });

  return getRegion(id);
};
